var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpressNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "90px",
    height: "90px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fffbfb",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,3c-6.627,0 -12,5.373 -12,12c0,6.627 5.373,12 12,12c6.627,0 12,-5.373 12,-12c0,-6.627 -5.373,-12 -12,-12zM24.084,10.843c0.003,0.096 0.018,0.178 0.018,0.278c0,1.043 -0.196,2.217 -0.783,3.687l-2.987,8.637c-0.634,0.402 -1.315,0.732 -2.034,0.984l-3.116,-8.531l-2.991,8.692c-0.64,-0.188 -1.253,-0.437 -1.833,-0.742l-4.611,-12.627c0.271,-0.661 0.609,-1.286 1.008,-1.868c0.102,0.002 0.217,0.005 0.307,0.005c1.076,0 2.743,-0.131 2.743,-0.131c0.556,-0.031 0.62,0.783 0.066,0.849c0,0 -0.558,0.065 -1.178,0.098l3.748,11.151l2.252,-6.757l-1.602,-4.396c-0.556,-0.031 -1.08,-0.096 -1.08,-0.096c-0.556,-0.033 -0.489,-0.882 0.065,-0.849c0,0 1.7,0.131 2.71,0.131c1.076,0 2.743,-0.131 2.743,-0.131c0.556,-0.031 0.62,0.783 0.066,0.849c0,0 -0.559,0.065 -1.178,0.098l3.72,11.066l1.028,-3.434c0.522,-1.337 0.783,-2.444 0.783,-3.327c0,-1.272 -0.456,-2.153 -0.849,-2.838c-0.521,-0.849 -1.012,-1.566 -1.012,-2.415c0,-0.849 0.58,-1.64 1.431,-1.794c1.084,0.936 1.962,2.097 2.566,3.411z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressNavIcon);
export default __webpack_public_path__ + "static/media/wordpress-nav-icon.ae294d1c16a713c02b7eec5bf0cb1924.svg";
export { ForwardRef as ReactComponent };